/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Contentplaceholder1Inputs */

const he_account_reviews_contentplaceholder1 = /** @type {(inputs: Account_Reviews_Contentplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שתף את חוויתך עם המוצר`)
};

const en_account_reviews_contentplaceholder1 = /** @type {(inputs: Account_Reviews_Contentplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your experience with this product`)
};

/**
* | output |
* | --- |
* | "Share your experience with this product" |
*
* @param {Account_Reviews_Contentplaceholder1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_contentplaceholder1 = /** @type {((inputs?: Account_Reviews_Contentplaceholder1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Contentplaceholder1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_contentplaceholder1(inputs)
	return en_account_reviews_contentplaceholder1(inputs)
});
export { account_reviews_contentplaceholder1 as "account_reviews_contentPlaceholder" }